module.exports = __webpack_public_path__ + "img/logo_dao.1af97d1f.png";